import styled from 'styled-components';

const IconDiv = styled.div`
  width: 48px;
  height: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export default IconDiv;
